<header class="header">
  <app-header
    class="w-full"
    (toogleSidebar)="toggleSidebar()"
    [user]="user()"
    [organization]="applicationContextService.getOrganizationFromContext()"
    [homePageUrl]="homePageUrl()"
    [isMobile]="isMobile()"
    [sidebarVisible]="sidebarVisible()"
  ></app-header>
</header>

<div class="layout-wrapper">
  <aside
    class="sidebar"
    [class.-translate-x-full]="!sidebarVisible()"
    [class.translate-x-0]="sidebarVisible()"
  >
    <div class="customMenu relative">
      <ng-container>
        @for (item of adminMenuItems; track item.label) {
          @if (item.children?.length) {
            <div class="menu-group">
              <button
                type="button"
                class="custom-menu-link menu-group__title cursor-pointer w-full"
                (click)="toggleGroup(item)"
                aria-expanded="{{ isGroupExpanded(item) }}"
              >
                <span class="menu-group__title-left">
                  @if (item.icon) {
                    <span
                      [class]="item.icon + ' menu-group__icon'"
                      aria-hidden="true"
                    ></span>
                  } @else if (item.appIcon) {
                    <app-icon
                      class="menu-group__icon"
                      [name]="item.appIcon"
                    ></app-icon>
                  }
                  {{ item.label }}
                </span>
                <span
                  class="pi pi-chevron-down menu-group__chevron"
                  [class.menu-group__chevron--open]="isGroupExpanded(item)"
                  aria-hidden="true"
                ></span>
              </button>
              @if (isGroupExpanded(item)) {
                @for (child of item.children; track child.label) {
                  @if (isRouteActive(child.route, true)) {
                    <span
                      class="custom-menu-link custom-menu-link--child sidebar-active-route"
                      [attr.aria-current]="currentAriaValue(child.route)"
                    >
                      @if (child.icon) {
                        <span
                          [class]="child.icon + ' custom-menu-link__icon'"
                        ></span>
                      } @else if (child.appIcon) {
                        <app-icon
                          class="custom-menu-link__icon"
                          [name]="child.appIcon"
                        ></app-icon>
                      }
                      <span class="custom-menu-link__label">{{
                        child.label
                      }}</span>
                    </span>
                  } @else {
                    <a
                      [routerLink]="child.route"
                      routerLinkActive="sidebar-active-route"
                      [routerLinkActiveOptions]="{ exact: true }"
                      class="custom-menu-link custom-menu-link--child"
                      tabindex="0"
                      (click)="toggleSidebar()"
                    >
                      @if (child.icon) {
                        <span
                          [class]="child.icon + ' custom-menu-link__icon'"
                        ></span>
                      } @else if (child.appIcon) {
                        <app-icon
                          class="custom-menu-link__icon"
                          [name]="child.appIcon"
                        ></app-icon>
                      }
                      <span class="custom-menu-link__label">{{
                        child.label
                      }}</span>
                    </a>
                  }
                }
              }
            </div>
          } @else {
            @if (item.action) {
              <button
                type="button"
                class="custom-menu-link w-full text-left"
                (click)="item.action(); toggleSidebar()"
              >
                @if (item.icon) {
                  <span [class]="item.icon + ' custom-menu-link__icon'"></span>
                } @else if (item.appIcon) {
                  <app-icon
                    class="custom-menu-link__icon"
                    [name]="item.appIcon"
                  ></app-icon>
                }
                <span class="custom-menu-link__label">{{ item.label }}</span>
              </button>
            } @else if (isRouteActive(item.route, item.id === 'home')) {
              <span
                class="custom-menu-link sidebar-active-route"
                [attr.aria-current]="currentAriaValue(item.route)"
              >
                @if (item.icon) {
                  <span [class]="item.icon + ' custom-menu-link__icon'"></span>
                } @else if (item.appIcon) {
                  <app-icon
                    class="custom-menu-link__icon"
                    [name]="item.appIcon"
                  ></app-icon>
                }
                <span class="custom-menu-link__label">{{ item.label }}</span>
              </span>
            } @else {
              <a
                [routerLink]="item.route"
                routerLinkActive="sidebar-active-route"
                [routerLinkActiveOptions]="{ exact: true }"
                class="custom-menu-link"
                tabindex="0"
                (click)="toggleSidebar()"
              >
                @if (item.icon) {
                  <span [class]="item.icon + ' custom-menu-link__icon'"></span>
                } @else if (item.appIcon) {
                  <app-icon
                    class="custom-menu-link__icon"
                    [name]="item.appIcon"
                  ></app-icon>
                }
                <span class="custom-menu-link__label">{{ item.label }}</span>
              </a>
            }
          }
        }
      </ng-container>
    </div>
  </aside>

  <div class="main-content">
    <nav aria-label="breadcrumb" class="breadcrumb-wrapper">
      <app-breadcrumb></app-breadcrumb>
    </nav>
    <main class="router-outlet-padding">
      <router-outlet></router-outlet>
    </main>
    <footer class="footer">
      <hr class="custom-hr" />
      <app-footer></app-footer>
    </footer>
  </div>
</div>
<p-toast key="admin" />
<app-spinner></app-spinner>
